import { Button } from "@sellar-io/components";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierPaymentInformationCreate } from "../../../../hooks/api/v2/supplierPaymentInformation/useSupplierPaymentInformationCreate";
import {
  EditBankDetailsForm,
  EditBankDetailsFormFieldValues,
} from "./EditBankDetailsForm";

export const CreateBankDetailsDialog = ({
  active,
  onDismiss,
  supplierId,
}: {
  active: boolean;
  onDismiss: () => void;
  supplierId: number;
}) => {
  const supplierPaymentInformationCreateMutation =
    useSupplierPaymentInformationCreate(supplierId);

  const form = useForm<EditBankDetailsFormFieldValues>({
    shouldUseNativeValidation: true,
  });
  const formId = useId();

  const onSubmit = (data: EditBankDetailsFormFieldValues) => {
    supplierPaymentInformationCreateMutation.mutate(
      {
        bankAccountNumber: data.bankAccountNumber
          ? data.bankAccountNumber
          : null,
        bankSortCode: data.bankSortCode ?? null,
      },
      {
        onSuccess: () => {
          onDismiss();
        },
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Add bank details"}
      />
      {supplierPaymentInformationCreateMutation.isError && (
        <Alert
          message={
            apiV2AssertError(supplierPaymentInformationCreateMutation.error)
              ?.response?.data.message ?? "Unknown error"
          }
        />
      )}
      <DialogContent>
        <EditBankDetailsForm onSubmit={onSubmit} form={form} formId={formId} />
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={supplierPaymentInformationCreateMutation.isPending}
        >
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
